import {GridInterface, GridOfOptions} from "../components/GridOfOptions";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {motion} from "framer-motion";
import navigationEffect from "../animations/navigationEffect";
import {CategoryProps} from "./Category";
import {Issue} from "../components/Issue";
import {Notebook} from "./Notebook";
import {API, apiCallbacks} from "../App";

export interface SubInterface {
    id: number;
    cover: string;
    title: string;
    year: number;
}

interface SubProps extends CategoryProps, apiCallbacks {
    skip: boolean;
}

export const Sub = ({allOptions, skip, requireAuthCallback, authCheckCatchCallback}: SubProps) => {
    const [options, setOptions] = useState<GridInterface[]>([]);
    const [errorOccurred, setErrorOccurred] = useState<boolean>(false);
    const {category, sub} = useParams();
    const [notebook, setNotebook] = useState<string>();
    const navigate = useNavigate();
    const localStorageTag = `${category}__${sub} notebook`

    useEffect(() => {
        let list: GridInterface[] = []

        fetch(`${API}/books/${category}/${sub}`, {credentials: "include"})
            .then(requireAuthCallback)
            .then((data) => {
                for (let k = 0; k < data.length; k++) {
                    list.push({
                        title: data[k].title,
                        smallerTitle: true,
                        subtitle: `${data[k].year} година`,
                        tag: `${data[k].id}`,
                        image: data[k].cover,
                    });
                }
                setOptions(list)
            })
            .catch(authCheckCatchCallback)
            .catch(() => setErrorOccurred(true));
        if (!skip) {
            const selectedNotebook = localStorage.getItem(localStorageTag);
            if (selectedNotebook) {
                setNotebook(selectedNotebook)
            }
        }
    }, [category, sub, localStorageTag, skip, requireAuthCallback, authCheckCatchCallback]);

    if (errorOccurred && !notebook) return (<Issue/>)

    function setStorage(option: GridInterface, e: React.MouseEvent<HTMLElement>) {
        e.preventDefault()
        localStorage.setItem(localStorageTag, option.tag);
        setNotebook(option.tag)
        navigate(`/category/${category}/${sub}`)
    }

    if (notebook && !skip) {
        return (
            <Notebook
                allOptions={allOptions}
                book={notebook}
                requireAuthCallback={requireAuthCallback}
                authCheckCatchCallback={authCheckCatchCallback}
            />
        )
    }
    return (

        <motion.div {...navigationEffect} className="text-center">
            <h1 className="w-100 mb-5">Избери Учебник</h1>
            <GridOfOptions
                options={options}
                onClick={setStorage}
            />
        </motion.div>
    );
};